var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncateringServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4167_31353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4376 59.9994H70.9996L66.7837 31.668H44.2217L48.4376 59.9994Z",
    fill: "#FFB878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5615 60.0009L66.7775 56.2227L70.9995 60.0009H62.5615Z",
    fill: "#ED984C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7775 56.2177V31.668L62.5615 59.9994L66.7775 56.2177Z",
    fill: "#E07E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0696 56.5882C62.7779 58.5483 61.095 59.9994 59.1132 59.9994H44.6393C42.1957 59.9994 40.3232 57.8276 40.6828 55.4107L43.7083 35.0792C44 33.119 45.683 31.668 47.6648 31.668H62.1387C64.5823 31.668 66.4548 33.8397 66.0951 36.2567L63.0696 56.5882Z",
    fill: "#FFB878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4668 29V34.3371C65.4668 34.3371 44.8115 34.3371 44.4102 34.3371C43.6859 34.3371 43.0986 33.1423 43.0986 31.6686C43.0986 30.1948 43.6859 29 44.4102 29C45.1346 29 65.4668 29 65.4668 29Z",
    fill: "#E07E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4668 29V34.3371C65.4668 34.3371 44.8115 34.3371 44.4102 34.3371C43.6859 34.3371 43.0986 33.1423 43.0986 31.6686C43.0986 30.1948 43.6859 29 44.4102 29C45.1346 29 65.4668 29 65.4668 29Z",
    fill: "#E07E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4659 34.3371C66.1903 34.3371 66.7775 33.1424 66.7775 31.6686C66.7775 30.1948 66.1903 29 65.4659 29C64.7415 29 64.1543 30.1948 64.1543 31.6686C64.1543 33.1424 64.7415 34.3371 65.4659 34.3371Z",
    fill: "#ED984C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 52C56.3137 52 59 49.3137 59 46C59 42.6863 56.3137 40 53 40C49.6863 40 47 42.6863 47 46C47 49.3137 49.6863 52 53 52Z",
    fill: "#FFF5F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4167_31353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3437 60.0023H38.0004L32.8324 25.2734H5.17578L10.3437 60.0023Z",
    fill: "#FFB878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6562 59.9986L32.8242 55.3672L37.9996 59.9986H27.6562Z",
    fill: "#ED984C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8242 55.3667V25.2734L27.6562 60.0023L32.8242 55.3667Z",
    fill: "#E07E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0374 57.4439C27.8186 58.914 26.5564 60.0023 25.07 60.0023H3.47945C1.64676 60.0023 0.242382 58.3735 0.512131 56.5607L4.78721 27.8319C5.00598 26.3617 6.26822 25.2734 7.75453 25.2734H29.3451C31.1778 25.2734 32.5822 26.9023 32.3125 28.715L28.0374 57.4439Z",
    fill: "#FFB878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2169 22V28.5423C31.2169 28.5423 5.89748 28.5423 5.40563 28.5423C4.51771 28.5423 3.79785 27.0777 3.79785 25.2711C3.79785 23.4646 4.51771 22 5.40563 22C6.29354 22 31.2169 22 31.2169 22Z",
    fill: "#E07E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2169 22V28.5423C31.2169 28.5423 5.89748 28.5423 5.40563 28.5423C4.51771 28.5423 3.79785 27.0777 3.79785 25.2711C3.79785 23.4646 4.51771 22 5.40563 22C6.29354 22 31.2169 22 31.2169 22Z",
    fill: "#E07E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2171 28.5423C32.1051 28.5423 32.8249 27.0777 32.8249 25.2711C32.8249 23.4645 32.1051 22 31.2171 22C30.3292 22 29.6094 23.4645 29.6094 25.2711C29.6094 27.0777 30.3292 28.5423 31.2171 28.5423Z",
    fill: "#ED984C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 50H29.167L27.667 60H3.15055C1.31645 60 -0.0883266 58.3688 0.183745 56.555L1.16699 50Z",
    fill: "#363A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.167 58C24.5477 58 25.667 56.8807 25.667 55.5C25.667 54.1193 24.5477 53 23.167 53C21.7863 53 20.667 54.1193 20.667 55.5C20.667 56.8807 21.7863 58 23.167 58Z",
    fill: "#D83289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 43C19.9807 43 22.667 40.3137 22.667 37C22.667 33.6863 19.9807 31 16.667 31C13.3533 31 10.667 33.6863 10.667 37C10.667 40.3137 13.3533 43 16.667 43Z",
    fill: "#FFF5F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4167_31353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(40 29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4167_31353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncateringServices);
export default __webpack_public_path__ + "static/media/uncatering-services.f16ed950a68191f19cfaf8bc12ddd098.svg";
export { ForwardRef as ReactComponent };